import { toast } from "react-toastify";

// message: string shown in the toast
// onCommit: called after 5s if not undone (make the real API call here)
// onUndo:   called immediately when user clicks Undo (restore optimistic state)
export const showUndoToast = (message, onCommit, onUndo) => {
  let undone = false;
  let committed = false;

  const timer = setTimeout(() => {
    if (!undone) { committed = true; onCommit(); }
  }, 5000);

  // Pass a render function — react-toastify injects closeToast correctly
  toast(
    ({ closeToast }) => (
      <div style={{ display: "flex", alignItems: "center", gap: 12, minWidth: 220 }}>
        <span style={{
          flex: 1, fontSize: 13, fontWeight: 500,
          color: "#0F172A", fontFamily: "'Inter', sans-serif",
        }}>
          {message}
        </span>
        <button
          onClick={() => {
            if (!committed) {
              undone = true;
              clearTimeout(timer);
              onUndo();
              closeToast();
            }
          }}
          style={{
            padding: "4px 12px",
            border: "1.5px solid #0D9488",
            borderRadius: "6px",
            background: "transparent",
            color: "#0D9488",
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
            fontFamily: "'Inter', sans-serif",
            flexShrink: 0,
          }}
        >
          Undo
        </button>
      </div>
    ),
    {
      autoClose: 5000,
      closeButton: true,
      icon: false,
      style: {
        borderRadius: "12px",
        boxShadow: "0 8px 28px rgba(15,23,42,0.14)",
        border: "1px solid #E2E8F0",
        padding: "10px 14px",
        background: "#fff",
      },
      progressStyle: { background: "#0D9488" },
    }
  );
};
